import { convertToChinese } from './converters/chinese';
import { convertToKorean } from './converters/korean';
import { convertToEnglish } from './converters/english';
import { convertToGerman } from './converters/german';
import { convertToSpanish } from './converters/spanish';
import { convertToFrench } from './converters/french';
import { convertToItalian } from './converters/italian';
import { convertToArabic } from './converters/arabic';
import { convertToThai } from './converters/thai';

export const convertAmount = (amount, languageCode) => {
  if (amount === '' || isNaN(amount)) return '等待轉換...';
  const num = parseFloat(amount);
  
  switch (languageCode) {
    case 'zh_HK': return convertToChinese(num, 'zh_HK');
    case 'zh_CN': return convertToChinese(num, 'zh_CN');
    case 'ko_KR': return convertToKorean(num);
    case 'en_US': return convertToEnglish(num, false);
    case 'en_GB': return convertToEnglish(num, true);
    case 'de_DE': return convertToGerman(num);
    case 'es_ES': return convertToSpanish(num);
    case 'fr_FR': return convertToFrench(num);
    case 'it_IT': return convertToItalian(num);
    case 'ar_AE': return convertToArabic(num);
    case 'th_TH': return convertToThai(num);
    default: return 'Unsupported Language';
  }
};

export const formatCurrency = (amount) => {
  if (!amount || isNaN(amount)) return '0.00';
  return parseFloat(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};